<template lang="pug">
  DefaultLayout
    CommonSection(v-if="users" :title="`Пользователи - ${users.length}`")
      FormBlock.b-users
        ._item(v-for="user in users")
          div {{ user.id }}
          UserAvatar(:user="user" :size="30")
          ._name(:class="{ notConfirmed: !user.accountConfirmed }") {{ user.name }} {{ user.surname }}
          ._email(:title="user.phone ? user.phone : 'Телефон не указан'") {{ user.email }}
          div {{ user.createdAt }}
          BaseSelect(v-if="isAdmin" v-model="user.selectedTariff" :options="tariffOptions" @change="setTariff(user)" hideNotSelected)
          ._phone(v-else) {{ user.phone ? user.phone : 'Телефон не указан' }}
          ._balance-inc
            Btn(v-if="isAdmin" xs narrow @click="increaseBalance(user)") +750
          ._balance
            div {{ user.accountBalance / 100 }}
          div
            template(v-if="isAdmin")
              Btn(xs narrow @click="toggleUserBlock(user)" green v-if="user.accountBlocked") unblock
              Btn(xs narrow @click="toggleUserBlock(user)" grey v-else) block
          div
            div(v-for="promo in user.promoEntered" :style="{ color: user.promoExecuted.includes(promo) ? 'green' : 'black' }") {{ promo }}
          div(:title="user.payments.map(p => p / 100).join(', ')") {{ user.payments.reduce((acc, val) => acc + val, 0) / 100 }}

</template>

<script>
import userApi from '@/api/user';
import userModel from '@/model/user';
import utils from '@/utils/common';

import DefaultLayout from '@/layouts/Default.vue';
import FormBlock from '@/components/FormBlock.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'AdminUserList',
  components: { UserAvatar, CommonSection, FormBlock, DefaultLayout, BaseSelect }, // eslint-disable-line
  data() {
    return {
      users: [],
    };
  },
  created() {
    userApi.fetchList({}, true)
      .then((r) => {
        this.users = r.items.map((u) => {
          const confirmedPayments = (u?.payments ?? []).filter(p => p.status === 'confirmed');
          return {
            ...u,
            createdAt: utils.convertDateToString(new Date(u.createdAt), 'short'),
            selectedTariff: u?.tariff?.['@id'],
            promoEntered: confirmedPayments.map(p => p.promoCode.toUpperCase()).filter(p => p),
            promoExecuted: (u?.customInfo?.usedPromoCodes ?? []).map(p => p.toUpperCase()),
            payments: confirmedPayments.map(p => p.amount),
          };
        });
      });
    this.$store.dispatch('tariff/fetchItems');
  },
  computed: {
    self() { return this.$store.state.auth.user; },
    isAdmin() { return this.self.roles.includes('ROLE_ADMIN'); },
    tariffOptions() {
      return this.$store.state.tariff.items.map((t) => ({ label: t.name, value: t['@id'] }));
    },
  },
  methods: {
    authenticate(user) {
      userModel.impersonate(user.email);
    },
    async setTariff(user) {
      const tariff = this.$store.state.tariff.items.find((t) => t['@id'] === user.selectedTariff);

      if (await this.$confirm(`Вы действительно хотите сменить пользователю [${user.name} ${user.surname}] тариф на [${tariff.name}]?`)) {
        userApi.update(user.id, { tariff: tariff['@id'] }, true)
          .then(() => { user.tariff = tariff; }); // eslint-disable-line no-param-reassign
      }
    },
    increaseBalance(user) {
      userApi.update(user.id, { accountBalance: user.accountBalance + 75000 }, true)
        .then(() => { user.accountBalance += 75000; }); // eslint-disable-line no-param-reassign
    },
    toggleUserBlock(user) {
      userApi.update(user.id, { accountBlocked: !user.accountBlocked }, true)
        .then(() => { user.accountBlocked = !user.accountBlocked; }); // eslint-disable-line no-param-reassign
    },
    addDiscount(user) {
      const price = Math.round(user.tariff.pricePerDay * 0.9);

      if (price === 0) return;

      userApi.update(user.id, { tariffInfo: [...user.tariffInfo, { days: 10, price }] }, true)
        .then((r) => { user.tariffInfo = r.tariffInfo; }); // eslint-disable-line no-param-reassign
    },
  },
};
</script>

<style scoped lang="scss">
  .users {
    display: grid;
    gap: 2px;

    &__item {
      display: grid;
      gap: 5px;
      align-items: center;
      grid-template-columns: 35px 35px 200px 200px 150px 150px 75px 100px 100px 1fr 1fr;

      &:nth-child(odd) {
        background: #f3f3ff;
      }
    }

    &__name {
      &.notConfirmed {
        color: #cf8600;
      }
    }
  }
</style>
